import { render, staticRenderFns } from "./MultipleInputAndOther.vue?vue&type=template&id=4736fe3b&scoped=true&"
import script from "./MultipleInputAndOther.vue?vue&type=script&lang=js&"
export * from "./MultipleInputAndOther.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4736fe3b",
  null
  
)

export default component.exports